module.exports = __webpack_public_path__ + "img/img-2.089bf101.svg";